import React, { useEffect, useState } from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import PaymentLayer from "../components/PaymentLayer";


const PaymentList = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>
        {/* Breadcrumb */}
        <Breadcrumb title="Payment" />


        {/* PaymentLayer */}
        <PaymentLayer />

      </MasterLayout>
    </>
  )
};

export default PaymentList;
